import React from "react";
import ContentLoader from "react-content-loader";

const Loader = () => {
	return (
		<ContentLoader
			// style={{ minWidth: '330px' }}
			speed={2}
			width={"100%"}
			height={300}
			viewBox="0 0 90 300"
			backgroundColor="#eaeaea"
			foregroundColor="#cdcdcd"
		>
			<rect x="8" y="5" rx="0" ry="0" width="75" height="12" />
			<rect x="30" y="22" rx="0" ry="0" width="29" height="11" />
			<rect x="16" y="49" rx="8" ry="8" width="58" height="26" />
			<rect x="16" y="89" rx="8" ry="8" width="58" height="26" />
			<rect x="16" y="129" rx="8" ry="8" width="58" height="26" />
			<rect x="16" y="169" rx="8" ry="8" width="58" height="26" />
			<rect x="16" y="209" rx="8" ry="8" width="58" height="26" />
			<rect x="16" y="249" rx="8" ry="8" width="58" height="26" />
		</ContentLoader>
	);
};

interface IFreeTimeLoaderProps {
	quantity: number;
}

export const DynamicFreeTimeLoader = ({ quantity }: IFreeTimeLoaderProps) => {
	const renderLoader = (quantity: number) => {
		const loaders = [];
		for (let i = 0; i < quantity; i++) {
			loaders.push(Loader);
		}

		return loaders.map((SkeletonLoader, index) => <SkeletonLoader key={index} />);
	};

	return <React.Fragment>{renderLoader(quantity)}</React.Fragment>;
};

const FreeTimeLoader = () => {
	return <Loader />;
};

export default FreeTimeLoader;
